import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { SignupService } from 'src/app/services/core/signup/signup.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sortBy } from 'lodash';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { UserPermission } from 'src/app/enums/enums';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { debounceTime, filter, Subject } from 'rxjs';

@UntilDestroy()

@Component({
  selector: 'app-signup-list',
  templateUrl: './signup-list.component.html',
  styleUrls: ['./signup-list.component.css']
})
export class SignupListComponent implements OnInit {
  users:any = []
  search: any = '';
  private searchSubject = new Subject<string>();
  signUpDetail:any
  filteredUsers:any = []
  currentPage = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS
  destroyedRef = inject(DestroyRef);
  userPermission=UserPermission;
  user: any;
  selectedStatus: any = true;
  status = true;
  selectedCompanies: any = [];

  constructor(
    private signupService: SignupService,
    private credentialService: CredentialService,
    private router: Router,
    public permissionService: PermissionService,
    private sharedDataService: SharedDataService
  ) {

  }
  ngOnInit() {
    this.getSignups(this.currentPage)
    this.initializeSearch();
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(untilDestroyed(this)).subscribe(user => {
        if (user) {
          this.user = user;
        }
      });
  }

  getSignups(page: number) {
    const queryparams: any = {
      isActive: this.status,
      limit: 50,
      sortBy: 'createdAt:desc',
      page
    }

    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryparams.search = trimmedSearch;
    }
    this.signupService.getSignups(queryparams).pipe(takeUntilDestroyed(this.destroyedRef))
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.users = data.results;
          this.filteredUsers = this.users;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  opendetailModal(item: any) {
    this.signUpDetail = item
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getSignups(page);
  }

  createCompany(item: any) {
    let payload = JSON.parse(JSON.stringify(item));
    payload.signup = item._id;
    payload.user = this.user.id;

    delete payload.address._id;
    delete payload.type;
    delete payload.services;
    delete payload.fleet;
    delete payload.drivers;
    delete payload.isCreated;
    delete payload.contactNumber;
    delete payload.createdAt;
    delete payload.updatedAt;
    delete payload.id;

    this.credentialService.saveComanies("", payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.updateSignup(item);
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "OK");
    })
  }

  updateSignup(item: any) {
    let payload = JSON.parse(JSON.stringify(item));
    this.signupService.updateStatus(item.id, { ...payload, isCreated: true, id: undefined }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        item.isCreated = true;
        this.router.navigate(['/credentials'], { state: { selectedItem: false } });
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "OK");
    })
  }



  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getSignups(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  onSelectStatus() {
    this.status = this.selectedStatus;
    this.getSignups(this.currentPage)
    this.selectedCompanies = [];

  }
  onSelectCompany(company: any) {
    const index = this.selectedCompanies.indexOf(company.id);

    if (index > -1) {
      company.isSelected = false;
      this.selectedCompanies.splice(index, 1);
    } else {
      company.isSelected = true;
      this.selectedCompanies.push(company.id);
    }
  }



  onSelectAllCompanies(event: any) {
    if (event.target.checked) {
      this.filteredUsers.forEach((company: any) => company.isSelected = true);
      this.selectedCompanies = this.filteredUsers.map((company: any) => company.id);
    } else {
      this.filteredUsers.forEach((company: any) => company.isSelected = false);
      this.selectedCompanies = [];
    }
  }

  bulkUpdate() {
    const payload = {
      isActive: !this.status,
      ids: this.selectedCompanies
    };

    this.signupService.bullkUpdate(payload)
      .subscribe({
        next: (data: any) => {
          this.getSignups(this.currentPage = 1);
          this.selectedCompanies = [];
        },
      });
  }


}
